// Kroger OAuth redirect target: exchanges `code` for tokens via backend (cookies / Bearer).
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import request from '../utils/request';

export default function KrogerCallback() {
  const [searchParams] = useSearchParams();
  const postedRef = useRef(false);

  useEffect(() => {
    if (postedRef.current) return;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const redirectUri = `${window.location.origin}/kroger-callback`;

    let orderId;
    let linkOnly = false;
    if (state) {
      try {
        const payload = JSON.parse(atob(state));
        orderId = payload.orderId;
        linkOnly = Boolean(payload.linkOnly);
      } catch (err) {
        console.error('Invalid state payload', err);
      }
    }

    if (!code) {
      return;
    }
    if (!linkOnly && !orderId) {
      console.error('Kroger callback: missing orderId (non link-only flow)');
      return;
    }
    postedRef.current = true;

    request
      .post('/orders/kroger/callback', {
        code,
        redirectUri,
        orderId,
        linkOnly,
      })
      .then((res) => {
        const linked = res.data?.linked === true;
        if (linked) {
          if (window.opener) {
            window.opener.postMessage({ type: 'kroger-linked' }, window.location.origin);
            window.close();
            return;
          }
          alert('Kroger account connected. Return to dispatch and click Add to cart.');
          return;
        }
        alert(`✅ ${res.data.addedCount || 0} items added to Kroger cart`);
        if (window.opener) {
          window.opener.postMessage(
            { type: 'kroger-cart-added', addedCount: res.data.addedCount, totalCount: res.data.totalCount },
            window.location.origin
          );
          window.close();
        }
      })
      .catch((err) => {
        console.error('Kroger callback failed', err?.response?.data || err);
        alert(err?.response?.data?.message || 'Kroger token exchange failed');
      });
  }, [searchParams]);

  return <p>Connecting to Kroger…</p>;
}
